import type { CSSProperties } from 'react'

const AVATAR_COLORS = ['#2557E8', '#E85D3C', '#10B981', '#8B5CF6', '#F59E0B']
const THUMB_PALETTES: [string, string][] = [
  ['#FFE5DD', '#C2410C'], ['#DBEAFE', '#1E40AF'], ['#D1FADF', '#065F46'],
  ['#FCE7F3', '#9D174D'], ['#FEF3C7', '#854D0E'], ['#E0E7FF', '#3730A3'],
  ['#E5EDFB', '#1357C2'], ['#FFEDD5', '#C2410C'],
]

interface AvatarProps {
  name: string
  size?: number
  color?: string
  style?: CSSProperties
}

export function Avatar({ name, size = 32, color, style }: AvatarProps) {
  const initial = (name || '?').charAt(0).toUpperCase()
  const c = color || AVATAR_COLORS[name?.charCodeAt(0) % 5 || 0]
  return (
    <div style={{
      width: size,
      height: size,
      borderRadius: '50%',
      background: c + '22',
      color: c,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: size * 0.42,
      fontWeight: 700,
      flexShrink: 0,
      ...style,
    }}>
      {initial}
    </div>
  )
}

interface ThumbProps {
  name: string
  size?: number
  hue?: number
  style?: CSSProperties
}

export function Thumb({ name, size = 44, hue = 0, style }: ThumbProps) {
  const idx = (hue + (name?.length || 0)) % THUMB_PALETTES.length
  const [bg, fg] = THUMB_PALETTES[idx]
  const initials = (name || '??').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()
  return (
    <div style={{
      width: size,
      height: size,
      borderRadius: 8,
      background: bg,
      color: fg,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: size * 0.32,
      fontWeight: 800,
      flexShrink: 0,
      fontFamily: 'Nunito, sans-serif',
      ...style,
    }}>
      {initials}
    </div>
  )
}
